import Component from './widget_preview_item.vue'
export default Component
